import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["storeConfig", "getLocalCartObject"]),
    minimumPuchase() {
      const config = this.storeConfig;
      return config.minimum_purchase;
    },
    isOverMinimum() {
      if (this.minimumPuchase && this.minimumPuchase > 0) {
        const cart = this.getLocalCartObject;
        const isOverMinimumPurchase = parseFloat(cart.subtotal) >= this.minimumPuchase;
        return isOverMinimumPurchase;
      }
      return true
    },
  },
};



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/components/checkout/order-minimum-mixin.js